<template>
    <j-modal
      :title="title"
      :visible="visible"
      width="50%"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      :body-style="{ overflow: 'hidden', overflowY: 'scroll' }"
      @cancel="handleCancel"
      @ok="handleOk"
      :okText="$t('确定')"
      :cancelText="$t('关闭')"
      :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    >
      <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="disableSubmit">
          <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-descriptions :title="$t('问题详情')">
                  <a-descriptions-item :label="$t('上报人')">{{ model.informant }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('上报人电话')">{{ model.informantPhone }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('现场坐标')">{{ model.coordinate }}</a-descriptions-item>
                  <!-- { 1: '紧急',2: '严重', 3: '一般', 4: '建议' }[model.problemLevel] -->
                  <a-descriptions-item :label="$t('问题等级')">{{
                    filterDictTextByCache('problemLevel',model.problemLevel)
                  }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('设备编号')">{{ model.deviceNum }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('设备名称')">{{ model.deviceName }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('设备类型')">{{
                    filterDictTextByCache('deviceType', model.deviceType)
                  }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('检测实体')">{{ model.detectEntity }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('创建时间')">{{ model.createTime }}</a-descriptions-item>
                </a-descriptions>
                <a-descriptions :column="1">
                  <a-descriptions-item :label="$t('问题描述')">{{ model.exceptionDescription }}</a-descriptions-item>
                  <a-descriptions-item :label="$t('现场图片或视频')"></a-descriptions-item>
                </a-descriptions>
                <div class="img-list">
                  <div
                    class="img-box"
                    v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                    :key="index"
                    @click="viewPicture(item)"
                  >
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
                <a-descriptions :column="1">
                  <a-descriptions-item :label="$t('是否现场已解决')">
                    <a-tag :color="model.whetherToSolve==1?'green':model.whetherToSolve==2?'red':''">
                      {{ model.whetherToSolve==1?$t('已解决'):model.whetherToSolve==2?$t('未解决'):'' }}
                    </a-tag>
                  </a-descriptions-item>
                </a-descriptions>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24" v-if="status==2">
                <a-form-model-item :label="$t('驳回原因')" prop="reasonsForRemark">
                  <a-textarea v-model="model.reasonsForRemark" :rows="3" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" v-else>
                <a-form-model-item :label="$t('搁置原因')" prop="reasonsForShelving">
                  <a-textarea v-model="model.reasonsForShelving" :rows="3" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>
      <j-modal
        :title="$t('预览')"
        :body-style="{ height: '480px' }"
        :visible="visiblePirture"
        :maskClosable="false"
        @cancel="visiblePirture = false"
        :okButtonProps="{ class: { 'jee-hidden': true } }"
      >
        <img :src="viewUrl" alt="" style="width: 100%; height: 100%" />
      </j-modal>
    </j-modal>
  </template>
    
    <script>
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import { httpAction, getAction } from '@/api/manage'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'modal',
    components: {
      JSelectUserByDep,
    },
    data() {
      return {
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        url: {
          edit: "/jeecg-engineering/InspectionWorkOrderController/exampleModifyTheInspectionWorkOrder",
          workOrderDetails: '/jeecg-engineering/InspectionWorkOrderController/workOrderDetails',
        },
        model: {},
        filterDictTextByCache: filterDictTextByCache,
        visiblePirture: false,
        viewUrl: '',
        status: 0,
      }
    },
  computed: {
    title() {
      return this.$t('确认')
    },
  validatorRules() {
            return {
            reasonsForRemark: [
              { required: true, message: this.$t('请输入驳回原因'), trigger: 'change' }
            ],
            reasonsForShelving: [
              { required: true, message: this.$t('请输入搁置原因'), trigger: 'change' }
            ]
          }
          }
},

    methods: {
      init(row,status) {
        this.visible = true
        this.disableSubmit = false
        this.status = status;
        getAction(this.url.workOrderDetails, { id: row.id }).then(res => {
          if (res.success) {
            this.model = Object.assign({}, res.result)
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handleOk(){
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.confirmLoading = true
            let params = JSON.parse(JSON.stringify(this.model))
            params.status = this.status;
            let message = '';
            if(this.status==2){
                message = this.$t('驳回成功！')
            }else{
                message = this.$t('搁置成功！')
            }
            httpAction(this.url.edit, params, 'post').then((res) => {
              if (res.success) {
                this.$message.success(message)
                this.confirmLoading = false
                this.close()
                this.$emit('ok')
              }else{
                this.$message.warning(res.message)
              }
            })
          }
        })
      },
  
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleCancel() {
        this.close()
      },
      viewPicture(item) {
        if (item.fileType == 'image') {
          this.visiblePirture = true
          this.viewUrl = item.url
        }
      },
    },
  }
  </script>
  <style lang="less" scoped>
  .img-list {
    display: flex;
    .img-box {
      width: 150px;
      height: 150px;
      margin: 5px;
      cursor: pointer;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      video {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }
  </style>